import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { AppButton } from '../form/button/button.model';
import { AppDialog } from './app-dialog.model';


@Component({
  selector: 'app-dialog',
  templateUrl: './app-dialog.component.html',
  styleUrls: ['./app-dialog.component.scss']
})
export class AppDialogComponent {

  btnOptions: { [key: string]: AppButton } = {
    primary: {
      color: 'accent',
      alignment: 'right',
      underline: 'none',
      text: 'OK',
      type: 'proceed',
      showImg: false,
    }
  };

  constructor(
    public dialogRef: MatDialogRef<AppDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AppDialog,
  ) {
    if (data.buttons && data.buttons.primaryButton) {
      this.btnOptions.primary.text = data.buttons.primaryButton.text;
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

}
